import React, { useState, useEffect } from 'react';
import QRCode from 'qrcode';
import '../styles/PartyEntranceQR.css';

const PartyEntranceQR = () => {
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [registrationUrl, setRegistrationUrl] = useState('');

  useEffect(() => {
    generateQRCode();
  }, []);

  const generateQRCode = async () => {
    // Get the registration URL (change localhost if needed for production)
    const baseUrl = window.location.origin;
    const regUrl = `${baseUrl}/register`;

    setRegistrationUrl(regUrl);

    try {
      // Generate QR code for the registration URL
      const qrUrl = await QRCode.toDataURL(regUrl, {
        width: 800,
        margin: 2,
        color: {
          dark: '#000000',
          light: '#ffffff'
        }
      });
      setQrCodeUrl(qrUrl);
    } catch (error) {
      console.error('Error generating QR code:', error);
    }
  };

  const printQR = () => {
    window.print();
  };

  const downloadQR = () => {
    const link = document.createElement('a');
    link.download = 'party-registration-qr.png';
    link.href = qrCodeUrl;
    link.click();
  };

  return (
    <div className="party-entrance-qr">
      <div className="qr-header no-print">
        <h2>🎉 Party Entrance QR Code</h2>
        <p className="qr-description">
          Display this QR code at the party entrance for guests to scan and register themselves
        </p>
      </div>

      <div className="qr-display-card">
        <div className="qr-card-header">
          <h1 className="party-title">📈 Stock Market Party</h1>
          <p className="party-subtitle">Scan to Join & Register</p>
        </div>

        <div className="qr-code-container">
          {qrCodeUrl ? (
            <img src={qrCodeUrl} alt="Registration QR Code" className="qr-code-image" />
          ) : (
            <div className="qr-loading">Generating QR Code...</div>
          )}
        </div>

        <div className="qr-instructions">
          <h3>📱 How to Join:</h3>
          <ol>
            <li>Scan this QR code with your phone camera</li>
            <li>Take a selfie for your profile picture</li>
            <li>Create your username & password</li>
            <li>Start trading with $10,000!</li>
          </ol>
        </div>

        <div className="qr-url">
          <p className="or-text">Or visit:</p>
          <p className="url-text">{registrationUrl}</p>
        </div>
      </div>

      <div className="qr-actions no-print">
        <button onClick={printQR} className="action-button print-button">
          🖨️ Print QR Code
        </button>
        <button onClick={downloadQR} className="action-button download-button">
          💾 Download QR Code
        </button>
        <button onClick={generateQRCode} className="action-button refresh-button">
          🔄 Regenerate
        </button>
      </div>

      <div className="usage-tips no-print">
        <h3>💡 Usage Tips:</h3>
        <ul>
          <li>
            <strong>Display Options:</strong> Print this page or display it on a tablet/laptop at the entrance
          </li>
          <li>
            <strong>Large Groups:</strong> Multiple people can scan simultaneously - no waiting!
          </li>
          <li>
            <strong>Guest Experience:</strong> Self-registration is fast (~2 minutes per person)
          </li>
          <li>
            <strong>Backup Plan:</strong> Guests can also type the URL directly if QR scanning doesn't work
          </li>
          <li>
            <strong>Network:</strong> Make sure guests are on WiFi or have good cellular signal
          </li>
        </ul>
      </div>

      <div className="alternative-methods no-print">
        <h3>🔧 Alternative Registration Methods:</h3>
        <p>
          If you prefer to register guests yourself (with host-controlled photos and passwords),
          use the <strong>Admin Panel → Party Controls → Register Guest</strong> tool instead.
        </p>
      </div>
    </div>
  );
};

export default PartyEntranceQR;
